const SIP_URI_IN_TEXT = /(?:sip|tel):([^@>;]+)/i;

const normalizePhoneNumber = (value) => {
  const raw = String(value || "").trim();
  if (!raw || raw.toLowerCase() === "anonymous") {
    return null;
  }
  const digits = raw.replace(/[^\d+]/g, "");
  return digits || raw;
};

const parsePhoneFromSipHeader = (raw) => {
  if (!raw) {
    return null;
  }
  const match = String(raw).match(SIP_URI_IN_TEXT);
  if (!match?.[1]) {
    return null;
  }
  return normalizePhoneNumber(match[1]);
};

/**
 * Resolve the external caller number from an inbound SIP INVITE.
 * Grandstream trunks often put the PSTN number in P-Asserted-Identity, not remoteIdentity.
 */
export const extractCallerFromInvitation = (invitation) => {
  const message = invitation?.incomingInviteRequest?.message ?? invitation?.request;
  if (message?.getHeader) {
    for (const headerName of ["P-Asserted-Identity", "Remote-Party-ID", "From"]) {
      const parsed = parsePhoneFromSipHeader(message.getHeader(headerName));
      if (parsed) {
        return parsed;
      }
    }
  }

  const remoteUser = invitation?.remoteIdentity?.uri?.user;
  const normalizedRemote = normalizePhoneNumber(remoteUser);
  if (normalizedRemote) {
    return normalizedRemote;
  }

  return "Unknown";
};
